import request from '@/utils/request';
//模板消息详情
export function getTemplateDetail(values) {
  return request('/wechat/queryTempDetail', {
    method: 'POST',
    data: values,
  });
}

//模板详情
export function getTemplateMessageDetail(values) {
  return request('/wechat/queryTempMsgDetail', {
    method: 'POST',
    data: values,
  });
}
//模板消息列表
export function getWechatTemplateMessageList(values) {
  return request('/wechat/queryTempMsgPage', {
    method: 'POST',
    data: values,
  });
}

//查询微信模板消息变量定义列表
export function getTempMsgVariableList() {
  return request('/wechat/queryTempMsgVariableList', {
    method: 'GET',
    // data: values,
  });
}

//新增模板
export function addTemplate(values) {
  return request('/wechat/addTempMsg', {
    method: 'POST',
    data: values,
  });
}

//更新模板
export function updateTemplate(values) {
  return request('/wechat/updateTempMsg', {
    method: 'POST',
    data: values,
  });
}

//获取AppidList
export function getAppIdList(values) {
  return request('/wechat/queryWmpTempAppId', {
    method: 'POST',
    data: values,
  });
}
